import { render } from "./CreateLiquidation2.vue?vue&type=template&id=d11b0c38"
import script from "./CreateLiquidation2.vue?vue&type=script&lang=js"
export * from "./CreateLiquidation2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__